export default "__VITE_ASSET__c9c6865a__"